/* consent-mini.js — mini-toast de consentimento (substitui o banner nativo do Shopify).
   Objetivo CRO: o banner nativo #shopify-pc__banner tapa ~43% da tela mobile e esconde a
   hero/oferta. Este mini-toast é uma pílula discreta no canto que NÃO tapa a oferta.

   INTEGRAÇÃO REAL (não é mockup):
   - Esconde o banner nativo do Shopify (#shopify-pc__banner) via CSS.
   - Ao clicar "OK", chama Shopify.customerPrivacy.setTrackingConsent() com TUDO=true
     (analytics + marketing + preferences + sale_of_data) — registra o consentimento de
     verdade na Customer Privacy API, não só esconde. Decisão do negócio: trackear tudo.
   - Grava também em localStorage pra não reaparecer (fallback + idempotência).

   Como ativar na LP: incluir ANTES do </body> (ou via section):
     <script src="{{ 'consent-mini.js' | asset_url }}" defer></script>
*/
(function () {
  'use strict';
  try {
    var KEY = 'gd_consent_mini_v2';

    // 1) esconde o banner NATIVO do Shopify (e variações de apps de consent, por garantia)
    var css = document.createElement('style');
    css.textContent = [
      '#shopify-pc__banner,#shopify-pc__prefs{display:none!important;visibility:hidden!important}',
      '#CybotCookiebotDialog,.cookieconsent,[id*="cookieconsent"] .cc-window,.cky-consent-container,.cky-overlay{display:none!important;visibility:hidden!important}',
      // ---- mini-toast ----
      '.gd-consent{position:fixed;left:10px;right:44px;bottom:10px;z-index:2147483000;',
      '  background:rgba(28,24,48,.95);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);',
      '  color:#fff;border-radius:12px;padding:9px 11px;display:flex;align-items:center;gap:9px;',
      '  box-shadow:0 6px 20px rgba(0,0,0,.32);font-family:inherit;font-size:12.5px;line-height:1.3;',
      '  max-width:440px;',
      // ENTRADA: desliza desfocado da DIREITA e foca ao chegar (cinematográfico, cara Guday)
      '  animation:gdConsentIn .6s cubic-bezier(.16,1,.3,1) both}',
      // desktop: pílula no canto inferior ESQUERDO (direita reservada pro chat de suporte)
      '@media(min-width:640px){.gd-consent{left:16px;right:auto;width:360px}}',
      '@keyframes gdConsentIn{from{opacity:0;transform:translateX(90%);filter:blur(6px)}to{opacity:1;transform:translateX(0);filter:blur(0)}}',
      // SAÍDA: desfoca e desliza pra ESQUERDA (caminho curto — o toast já está no canto esquerdo)
      '@keyframes gdConsentOut{from{opacity:1;transform:translateX(0);filter:blur(0)}to{opacity:0;transform:translateX(-60%);filter:blur(6px)}}',
      '.gd-consent.gd-leaving{animation:gdConsentOut .4s cubic-bezier(.4,0,1,.6) both;pointer-events:none}',
      '.gd-consent .gd-em{font-size:16px;flex:none}',
      '@media(prefers-reduced-motion:reduce){.gd-consent,.gd-consent.gd-leaving{animation:none}}',
      '.gd-consent .gd-txt{flex:1;min-width:0}',
      '.gd-consent .gd-txt a{color:#C5F26D;text-decoration:underline;font-weight:600}',
      '.gd-consent .gd-ok{flex:none;background:#C5F26D;color:#243406;font-weight:800;border:0;',
      '  border-radius:7px;padding:7px 16px;font-size:12.5px;cursor:pointer;font-family:inherit}',
      '.gd-consent .gd-ok:active{transform:scale(.96)}'
    ].join('');
    document.head.appendChild(css);

    // já respondeu antes? não mostra de novo
    if (localStorage.getItem(KEY)) return;

    // registra o consentimento REAL na Customer Privacy API do Shopify (trackear tudo)
    function grantConsent() {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
      try {
        var api = window.Shopify && window.Shopify.customerPrivacy;
        if (api && typeof api.setTrackingConsent === 'function') {
          api.setTrackingConsent({
            analytics: true, marketing: true, preferences: true, sale_of_data: true
          }, function () { /* consentimento registrado */ });
        }
      } catch (e) { /* nunca quebra a página */ }
    }

    function build() {
      if (document.querySelector('.gd-consent')) return;
      var el = document.createElement('div');
      el.className = 'gd-consent';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-label', 'Aviso de cookies');
      el.innerHTML =
        '<span class="gd-em" aria-hidden="true">🍪</span>' +
        '<span class="gd-txt">Usamos cookies pra melhorar sua experiência. ' +
        '<a href="/policies/privacy-policy" target="_blank" rel="noopener">Saiba mais</a></span>' +
        '<button class="gd-ok" type="button">OK</button>';
      document.body.appendChild(el);
      el.querySelector('.gd-ok').addEventListener('click', function () {
        grantConsent();
        el.classList.add('gd-leaving');          // dispara a animação de saída (recolhe + desliza)
        setTimeout(function () { el.remove(); }, 340);
      });
    }

    if (document.body) build();
    else document.addEventListener('DOMContentLoaded', build);
  } catch (e) { /* consentimento nunca pode quebrar a página */ }
})();
